<template>
	<ul :class="{'conversation-list': true, 'load-more': $store.state.conversationLoadStatus}">
		<template v-if="list.length">
			<li v-for="(obj, key) in list" :class="{unread: obj.unread && obj.unread > 0, keep: obj.uncloseable, active: obj.id == currentSessionId, unreply: obj.unreply, warn: obj.warn, keyhover: key == $store.state.keyHover && obj.id != currentSessionId}" @click="changeCurrentConversation(obj.id, $event)">
				<span :class="{thumb: true, icon: true, 'icon-wangwang': currentShop.serviceType == $store.state.TYPES.WANGWANG, 'icon-liaotian1': currentShop.serviceType != $store.state.TYPES.WANGWANG}">
					<img v-if="obj.headThumb" :src="obj.headThumb" :alt="obj.clientNickName">
				</span>
				
				<a v-if="currentShop.id != -1 && !obj.closed" href="javascript:;" title="关闭会话" class="close icon icon-cha" @click="closeInList(obj.id, true)"></a>

				<div class="aside-box">
					<span class="time" v-html="timeToTxt(obj)"></span>
					<a class="mark-long-session" @click="markAsLongSession(obj)"><span></span></a>
				</div>

				<span class="name">{{ obj.clientNickName }}</span>
				<div class="message" v-html="msgHtmlToTxt(obj)"></div>
			</li>
			<p v-if="showNoMoreData" class="shift">没有更多会话了...</p>
		</template>
		<p v-else v-show="!$store.state.conversationLoadStatus" class="shift">没有更多会话了...</p>
	</ul>
</template>

<script>
import bus from '@/config/eventBus'
export default {
	name: 'conversationList',
	data () {
		return {
			interval: null,
			pageNum: 2,
			disScroll: false,
			showNoMoreData: false
		}
	},
	props: ['sortType'],
	computed: {
		shopList () {
			return this.$store.state.shopList;
		},
		currentShop () {
			return this.$store.state.currentShop;
		},
		currentSessionId() {
			return this.$store.state.currentSessionId;
		},
		list () {
			return this.$store.state.conversationList;
		},
		conversationType () {
			return this.$store.state.conversationType;
		}
	},
	mounted () {
		document.getElementsByClassName("conversation-list")[0].addEventListener('scroll', this.getMoreConversation);
	},
	watch: {
		list: {
			deep: true,
			handler () {
				let obj = this.list.find(o => o.id == this.currentSessionId);
				!obj && this.changeCurrentConversation(this.list.length ? this.list[0].id : null);
			}
		},
		currentShop: {
			deep: true,
			handler (now, old) {
				if (now.id == old.id) return;
				this.reSetData();
			}
		},
		conversationType () {
			this.reSetData();
		},
		sortType () {
			this.reSetData();
		}
	},
	methods: {
		// 重置参数
		reSetData () {
			var self = this;

			self.pageNum = 2;
			self.disScroll = false;
			self.showNoMoreData = false;
		},

		// 计算等待时间(当前时间后10天还是小于了开始等待时间，说明客服已回复，等待时间为null)
		waitingTime (startWaitDate) {
			var self = this,
				waitingTime = ((+new Date()) - (+new Date(startWaitDate)))/60000;

			return waitingTime;
		},

		// 把html转换为纯文本
		msgHtmlToTxt (obj) {
			var self = this,
				str = '';
			if (obj.error) {
				str = '<span style="color:#f4393e">' + obj.error + '</span>';
			} else if (obj.lastMsg && obj.lastMsg.sendStatus === 0) {
				str = '<span class="fail">' + TJ_IM.msgHtmlToTxt(obj.lastMsg.msgContent || '', self.currentShop.serviceType) + '</span>';
			} else {
				str = TJ_IM.msgHtmlToTxt(obj.lastMsg && obj.lastMsg.msgContent ? obj.lastMsg.msgContent : '', self.currentShop.serviceType);
			}
			return str;
		},

		// 时间文本
		timeToTxt (obj) {
			var self = this,
				str = '';

			if (obj.aiReply > 0) return 'AI已回';
			if (!obj.unreply) return '已回';
			if (!obj.lastClientMsgTime) return '';

			var waitingTime = self.waitingTime(obj.lastClientMsgTime),
				udT = +new Date() - waitingTime * 60 * 1000,
				udyyyymmdd = new Date(udT).format('yyyy-MM-dd'),
				today = new Date().format('yyyy-MM-dd');

			if (udyyyymmdd != today) {
				str = new Date(udT).format('MM-dd');
			} else if ( waitingTime >= 60 ) {
				str = parseInt(waitingTime / 60 ) + '小时前';
			} else if ( waitingTime >= 1 ) {
				str =  parseInt(waitingTime) + '分钟前';
			} else {
				str = '刚刚';
			}

			return str;
		},
			
		// 会话标心
		markAsLongSession (obj) {
			var self = this,
				data = {
					serviceType: this.currentShop.serviceType,
					toggle: !obj.uncloseable,
					sessionId: obj.id
				};

			if (obj.pendingFlag) return;
			obj.pendingFlag = true;

			this.$axios.post(API_ROOT.url + '/SessionApi.uncloseSession', data).then(result => {
				let tempObj = this.list.find(o => o.id == data.sessionId) || {}
				tempObj.pendingFlag = false

				if (result.status) {
					TJ_DB.edit(TJ_DB.C_Table, data.sessionId, { uncloseable: data.toggle }, () => {
						bus.$emit('bus_updateConversationList')
					}, () => {
						bus.$emit('bus_updateConversationList')
					});
				} else {
					self.$alert('会话标心失败，失败原因：' + result.msg);
				}
			}, response => {
				let tempObj = this.list.find(o => o.id == data.sessionId) || {}
				tempObj.pendingFlag = false
				self.$alert('会话标心失败，错误码(' + response + ')');
			})
		},

		// 修改未读会话数
		editUnReadNum (sessionId, callback) {
			var self = this;

			TJ_DB.get(TJ_DB.C_Table, "'id' == '" + sessionId + "'", function(result) {
				if (!result.length) {
					if (callback && typeof callback == 'function') callback();
					return;
				};
				
				var shopId = result[0]['shopId'];

				TJ_DB.edit(TJ_DB.C_Table, sessionId, {unread: 0}, function() {
					TJ_DB.get(TJ_DB.C_Table, "'shopId' == " + shopId + " && 'unread' > 0", function(result) {
						for (var i = 0; i < self.shopList.length; i++) {
							if (self.shopList[i].id == shopId) {
								self.shopList[i].unreadNum = result.length
								self.$store.commit('changeShopList', JSON.parse(JSON.stringify(self.shopList)));
								break;
							}
						}
						if (callback && typeof callback == 'function') callback();
					});
				});
			});
		},

		// 改变当前会话
		changeCurrentConversation (sessionId, e) {
			let data = {
				serviceType: this.currentShop.serviceType,
				sessionId: sessionId
			};

			$('.ima_textarea').focus();
			if (e && (e.target.classList.contains('close') || e.target.classList.contains('mark-long-session')) || sessionId == this.currentSessionId) return;

			let arr = this.list.map(o => {
				if (o.id == sessionId) {
					o.unread = 0
				}
				return o
			})

			this.$store.commit('changeConversationList', arr);
			this.$store.commit('changeCurrentSessionId', sessionId)

			if (sessionId) {
				this.editUnReadNum(sessionId);
				this.$axios.post(API_ROOT.url + '/SessionApi.markUnread', data).then(result => {}, response => {});
			}
		},
			
		// 关闭会话(needRts：是否需要向后台发送请求)
		closeSession (sessionId, needRts) {
			if (!sessionId) return;
			let i = this.list.findIndex(o => o.id == sessionId);

			// 判断关闭的会话是否在当前会话列表中
			if (!~i) {
				needRts ? this.submitCloseSession(sessionId) : this.handleCloseSession(sessionId);
			} else {
				this.closeInList(sessionId, needRts);
			}
		},

		// 关闭在列表中的会话(needRts：是否需要向后台发送请求)
		closeInList(sessionId, needRts) {
			if (!needRts) {
				let arr = this.list.filter(o => o.id != sessionId)
				this.$store.commit('changeConversationList', arr);
				this.handleCloseSession(sessionId);
			} else {
				this.$confirm('确定要关闭会话？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.submitCloseSession(sessionId);
				});
			}
		},

		// 发送关闭会话请求
		submitCloseSession (sessionId) {
			let conversationObj = this.list.find(o => o.id == sessionId) || {},
				data = {
					serviceType: this.currentShop.serviceType,
					sessionId: sessionId
				};

			if (conversationObj.pendingClose) return;
			conversationObj.pendingClose = true;

			this.$axios.post(API_ROOT.url + '/SessionApi.closeSession', data).then(result => {
				let obj = this.list.find(o => o.id == data.sessionId) || {};
				obj.pendingClose = false;
				
				if (result.status) {
					this.handleCloseSession(data.sessionId, () => {
						bus.$emit('bus_updateConversationList')
					})
					this.$message.success('操作成功')
				} else {
					this.$alert('关闭会话失败，失败原因：' + result.msg);
				}
			}, response => {
				let obj = this.list.find(o => o.id == data.sessionId) || {};
				obj.pendingClose = false;
				this.$alert('关闭会话失败，错误码(' + response + ')');
			})
		},

		// 处理关闭会话
		handleCloseSession (sessionId, callback) {
			this.editUnReadNum(sessionId, function () {
				TJ_DB.del(TJ_DB.C_Table, "'id' == '" + sessionId + "'", function() {
					TJ_DB.del(TJ_DB.M_Table, "'sessionid' == '" + sessionId + "'", function() {
						callback && callback()
					});
					sessionStorage.removeItem('UNSEND-' + sessionId);
				});
			});
		},

		// 获取更多会话
		getMoreConversation () {
			var self = this,
				$list = document.getElementsByClassName("conversation-list")[0],
				sT = $list.scrollTop,
				cH = $list.clientHeight,
				sH = $list.scrollHeight,
				data = {
					serviceType: this.currentShop.serviceType,
					shopId: this.currentShop.id,
					sortBy: this.sortType,
					sessionOrder: this.sortType == 'startTime' ? 'asc' : 'desc',
					pageNum: this.pageNum
				};

			if (!this.conversationType || this.conversationType == '1') {
				data.uncloseable = false
				data.closed = this.conversationType ? 1 : 0
			} else if (this.conversationType === '2') {
				data.uncloseable = true
			}

			if (cH + sT + 100 < sH) return;

			if (this.$store.state.conversationLoadStatus || this.disScroll || !this.list.length) return;
			this.$store.commit('changeConversationLoadStatus', true);

			if (this.currentShop.id == -1) {
				let data = {
					serviceType: this.currentShop.selectObj.serviceType,
					shopId: this.currentShop.selectObj.id,
					pageNum: this.pageNum
				};

				this.$axios.post(API_ROOT.url + '/SessionApi.getExpiredOfflineSessionList', data).then(result => {
					if (this.currentShop.id != -1 || data.shopId != this.currentShop.selectObj.id) return;
					
					if (result.status) {
						if (result.data.length) {
							this.$store.commit('changeConversationList', [...this.list, ...result.data]);
							this.pageNum++;
						} else {
							this.disScroll = true;
							this.showNoMoreData = true;
							setTimeout(() => {
								this.showNoMoreData = false;
							}, 1000);
						}
					} else {
						this.$alert('获取更多会话列表失败，失败原因：' + result.msg);
					}
					this.$store.commit('changeConversationLoadStatus', false);
				}, response => {
					this.$alert('获取更多会话列表失败，错误码(' + response + ')');
					this.$store.commit('changeConversationLoadStatus', false);
				});
			} else {
				self.$axios.post(API_ROOT.url + '/SessionApi.getSessionList', data).then(result => {
					if (data.shopId != self.currentShop.id || data.sortBy != self.sortType || !data.closed != !self.conversationType) return;
					
					if (result.status) {
						if (result.data.length) {
							self.$store.commit('changeConversationList', [...this.list, ...result.data]);
							self.pageNum++;
						} else {
							self.disScroll = true;
							self.showNoMoreData = true;
							setTimeout(function() {
								self.showNoMoreData = false;
							}, 1000);
						}
					} else {
						self.$alert('获取更多会话列表时出错，错误原因：' + result.msg);
					}
					self.$store.commit('changeConversationLoadStatus', false);
				}, response => {
					self.$alert('获取更多会话列表时出错，错误码(' + response + ')');
					self.$store.commit('changeConversationLoadStatus', false);
				})
			}
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/pages/conversation/conversationList.vue